import { formatISO, parseISO } from 'date-fns'
import { ISO8601Duration } from '@opallabs/concepts'

/**
 * Takes in an ISO Date (yyyy-MM-dd) string and a duration string (P12D). Returns
 * an ISO Date (yyyy-MM-dd) string that results from adding the duration to the input date.
 *
 * A `null` starting date will result in a `null` end date. A `null` duration will simply return
 * the start date as-is.
 */
export function computeEndDateFromDuration(
  startDateString: string | null,
  duration: string | null
): string | null {
  if (startDateString === null) {
    return null
  }

  if (duration === null) {
    return startDateString
  }

  try {
    const startDate = parseISO(startDateString)
    const endDate = ISO8601Duration.add(startDate, duration)
    return formatISO(endDate, { representation: 'date' })
  } catch (e) {
    if (e instanceof Error) {
      console.error('Unable to compute end date:', e.message)
    }
    return null
  }
}
